import request from "@/utils/request";
import qs from "qs";

export function userInfo(data) {
  return request({
    url: "/userInfo",
    method: "post",
    data: qs.stringify(data)
  });
}

export function roleIdsByLoginStr(data) {
  return request({
    url: "/role_user/roleIdsByLoginStr",
    method: "post",
    data: qs.stringify(data)
  });
}

export function login(data) {
  return request({
    url: "/login",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getMenu(data) {
  return request({
    url: "/getMenu",
    method: "post",
    data: qs.stringify(data)
  });
}

export function sendSms(data) {
  return request({
    url: "/sendSms",
    method: "post",
    data: qs.stringify(data)
  });
}

export function getInfo(token) {
  return request({
    url: "/info",
    method: "get",
    params: { token }
  });
}

//查询全部运动员的基本信息
export function player_namedata() {
  return request({
    url: "/data/player_data_total/select",
    method: "get",
  });
}




//查询全部运动员的个项数据汇总
export function player_Alldata(data) {
  return request({
    url: "/data/player_data_total/data",
    method: "get",
    params: data
  });
}

export function logout(data) {
  return request({
    url: "/logout",
    method: "get",
    data: qs.stringify(data)
  });
}

//查看是否为付费单位
export function org_access_money(data) {
  return request({
    url: "data/org_access/select/money",
    method: "get",
    params: data
  });
}

// 获取全部体育局名称
export function real_all_sheet_orgName(data) {
  return request({
    url: "/data/sheet1_module_select/real_all_sheet_orgName ",
    method: "get",
    data: qs.stringify(data)
  });
}

// 二三级菜单对应
export function webMenu(data) {
  let menu = JSON.parse(window.localStorage.getItem("menu"));
  if (!menu) {
    this.$store.dispatch("user/logout");
    this.$router.push(`/login`);
    return;
  }
  let menuData = menu.menu23;
  let path = window.localStorage.getItem("path");
  let menuObj = {};
  menuData.forEach(item => {
    if (item.children.length != 0) {
      menuObj[item.url] = [];
      item.children.forEach(children => {
        menuObj[item.url].push(children.url);
      });
    }
  });
  if (path) {
    return menuObj[path];
  } else {
    return [];
  }
}
